import { FoundUserLookupResult } from "../../services/userLookupService";
import { usePromiseStateOf } from "../../utils";
import { translation } from "../../translations";
import React from "react";
import { Typography } from "@mui/material";

export const DeletingAccountStepView = (props: {
  readonly foundUserLookupResult: FoundUserLookupResult;
}) => {
  const deletingUserState = usePromiseStateOf(() =>
    props.foundUserLookupResult.delete(),
  );

  return (
    <Typography align="center">
      {(() => {
        switch (deletingUserState.state) {
          case "pending":
            return translation.deletingAccount;
          case "fulfilled":
            return translation.accountWasDeleted;
          case "rejected":
            return translation.errorWhenDeletingAccount;
        }
      })()}
    </Typography>
  );
};
